import React, { Suspense, useCallback, useContext, useEffect } from "react";
import { Routes, Route, useParams, useLocation } from "react-router-dom";
import PulseLoader from "../Loader/PulseLoader";
import { ReservationContext } from "../../context/ReserationContext";
import { useGetReservationMutation } from "../../hooks/use-find-reservation";
import ShashiUnplugged from "../pages/check-in/ShashiUnplugged";
import ShashiUnpluggedOpen from "../pages/check-in/ShashiUnpluggedOpen";
import ShashiUnpluggedOpenGuest from "../pages/check-in/ShashiUnpluggedOpenGuest";
import ShashiUnpluggedGuest from "../pages/check-in/ShashiUnpluggedGuest";

// Lazy-loaded components
const CheckInSuccessful = React.lazy(
  () => import("../pages/check-in/CheckInSuccessful"),
);
const ExpressCheckInSuccessful = React.lazy(
  () => import("../pages/check-in/ExpressCheckInSuccessful"),
);
const MailSendSuccessful = React.lazy(
  () => import("../pages/check-in/MailSendSuccessful"),
);
const PersonalizeYourStay = React.lazy(
  () => import("../pages/check-in/PersonalizeYourStay"),
);
const ReviewCostSummary = React.lazy(
  () => import("../pages/check-in/ReviewCostSummary"),
);
const RoomPreferences = React.lazy(
  () => import("../pages/check-in/RoomPreferences"),
);
const SelectRoom = React.lazy(() => import("../pages/check-in/SelectRoom"));
const Verification = React.lazy(() => import("../pages/check-in/Verification"));
const MultipleCheckInPage = React.lazy(
  () => import("../pages/check-in/MultipleCheckInPage"),
);
const MultipleCheckInIntroPage = React.lazy(
  () => import("../pages/check-in/MultipleCheckInPageIntro"),
);
const CombinedCheckInPage = React.lazy(
  () => import("../pages/check-in/CombinedCheckInPage"),
);
const CheckInError = React.lazy(() => import("../pages/check-in/CheckinError"));
const ServerError = React.lazy(() => import("../pages/check-in/ServerError"));

//@ts-ignore
const HotelWebCheckInAuthPage = React.lazy(
  () => import("../pages/check-in/HotelWebCheckInAuthPage"),
);

// Routes array
const routes = [
  {
    path: "/",
    element: <CombinedCheckInPage />,
  },
  {
    path: "/multiple-check-in-page",
    element: <MultipleCheckInPage />,
  },
  {
    path: "/scan-document",
    element: <MultipleCheckInIntroPage />,
  },
  {
    path: "/check-in-successful",
    element: <CheckInSuccessful />,
  },
  {
    path: "/express-check-in",
    element: <ExpressCheckInSuccessful />,
  },
  {
    path: "/mail-send-successful",
    element: <MailSendSuccessful />,
  },
  {
    path: "/personalize-your-stay",
    element: <PersonalizeYourStay />,
  },
  {
    path: "/review-cost-summary",
    element: <ReviewCostSummary />,
  },
  {
    path: "/room-preferences",
    element: <RoomPreferences />,
  },
  {
    path: "/select-room",
    element: <SelectRoom />,
  },
  {
    path: "/verification",
    element: <Verification />,
  },
  {
    path: "/shashiunplugged/:token",
    element: <ShashiUnplugged />,
  },
  // {
  //   path: '/shashiunplugged/:token/:isPin',
  //   element: <ShashiUnpluggedGuest />,
  // },
  {
    path: "/shashiunplugged/:token/:isPin",
    element: <ShashiUnpluggedOpenGuest />,
  },
  {
    path: "/shashiunpluggedopen/:token",
    element: <ShashiUnpluggedOpen />,
  },
  {
    path: "/:hId/:wId",
    element: <HotelWebCheckInAuthPage />,
  },
  {
    path: "/error",
    element: <CheckInError />,
  },
  {
    path: "/server-error",
    element: <ServerError />,
  },
];

// const ReservationComponent = () => {
//   return (
//     <div>ReservationComponent</div>
//   )
// }

// const ReservationComponent = () => {
//   const [inputValue, setInputValue] = useState('');
//   const { reservations, setReservations } = useContext(ReservationContext);

//   const navigate = useNavigate();

//   // const { data, error, isLoading, refetch } = useGetReservationQuery(finalValue);

//   const {mutate , isPending , data , error} = useGetReservationMutation()

//   if (error) return <div>Error: {error.message}</div>;
//   if (data?.success) {
//     //save it to context
//     setReservations(data.result.data);
//     console.log("reservation",reservations);
//     // console.log(data);
//     navigate('/check-in-successful');
//   }

//   const handleSubmit = () => {
//     mutate(inputValue)
//   };

//   return (
//     <div className="flex flex-col items-center justify-center h-screen bg-gray-100">
//       <div className="bg-white p-6 rounded-lg shadow-md w-80">
//         <input
//           type="text"
//           placeholder="Enter reservation ID"
//           value={inputValue}
//           onChange={(e) => setInputValue(e.target.value)}
//           className="w-full px-4 py-2 mb-4 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
//         />
//         <button
//           onClick={handleSubmit}
//           className="w-full bg-blue-500 text-white py-2 rounded hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-500"
//         >
//           Submit
//         </button>
//       </div>
//     </div>
//   );
// };

// Main App Component

const App = () => {
  const { reservations, setReservations } = useContext(ReservationContext);
  const hId = localStorage.getItem("hId");
  const wId = localStorage.getItem("wId");
  const { mutate, isPending, data, error } = useGetReservationMutation({
    hId,
    wId,
  });

  const location = useLocation();
  console.log(location);

  useEffect(() => {
    if (
      hId &&
      wId &&
      routes.map((route) => route.path).includes(location.pathname) &&
      location.pathname !== "/" &&
      !location.pathname.includes("shashiunplugged") &&
      !location.pathname.includes("multiple-check-in") &&
      !location.pathname.includes("server-error")
    ) {
      mutate();
    }
  }, []);

  useEffect(() => {
    if (data?.result?.data) {
      setReservations(data.result.data);
    }
  }, [data]);

  return (
    <Suspense
      fallback={
        <div className="w-[100vw] h-[100vh] flex align-center items-center justify-center">
          <PulseLoader />
        </div>
      }
    >
      <Routes>
        {routes.map((route, index) => (
          <Route path={route.path} element={route.element} />
        ))}
      </Routes>
      {isPending && <PulseLoader isFull={true} />}
    </Suspense>
  );
};

export default App;
